import React from 'react';
import clsx from "clsx";
import {FaBuilding} from "react-icons/fa";
import {FaCircleUser} from "react-icons/fa6";
import logo from "../../../../../public/img/sw-logo.svg";

const STEPS = [
    {id: "corporation", name: "Corporação", Icon: FaBuilding},
    {id: "user", name: "Usuário", Icon: FaCircleUser},
];

const InstallerSteps = ({step}) => (
    <nav className={"fixed top-0 left-0 bottom-0 z-[1009] w-[220px] bg-[var(--blue-darker,#001327)] text-[#c9d2dd]"}>
        <div className={"flex h-[100px] items-center justify-center"}>
            <img src={logo} alt={"Sentry"} className={"max-w-[80%] h-auto"} />
        </div>

        <ul className={"list-none m-0 p-0"}>
            {STEPS.map(({id, name, Icon}) => (
                <li
                    key={id}
                    id={`menu-${id}`}
                    className={clsx(
                        "flex items-center gap-[0.625rem] px-[14px] py-[10px] text-[13px]",
                        step === id && "bg-[#001327] text-white border-l-2 border-[var(--blue-bright,#1f8efa)] pl-[12px]",
                    )}
                    title={name}
                >
                    <Icon className={"w-[18px] shrink-0"} />
                    <span>{name}</span>
                </li>
            ))}
        </ul>
    </nav>
);

export default InstallerSteps;
